import React from 'react'
import SearchComponent from './SearchComponent'
import FilteredList from './FilteredList'
import WithBlur from '../withBlur'
import { PopupConsumer } from '../../context/popup'

import styles from './IndustrieSearch.module.scss'


class IndustrieSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = { textInsert: '' }
  }

  listUsefulElements() {
    const { textInsert } = this.state
    const data = this.props.data
    return data.filter(
      (e) => ( e.node.entry.Name.toUpperCase().substring(0, textInsert.length) === textInsert.toUpperCase() )
    ).length
  }

  changeText = (text) => this.setState({ textInsert: text })

  render() {
    const data = this.props.data
    const servizi = this.props.tags
    const {textInsert} = this.state
    return (
    <div
      className={styles.container}
    >
      <PopupConsumer>
        {
          context => (
            <WithBlur>
              <SearchComponent
                size={this.listUsefulElements()}
                text={textInsert}
                reset={() => this.changeText(``)}
                onChange={(e) => this.changeText(e.target.value)}
                openPopup={context.openPopup}
              />
              <FilteredList
                tags={data}
                text={textInsert}
                servizi={servizi}
                size={this.listUsefulElements()}
                openPopup={context.openPopup}
              />
            </WithBlur>)
        }
      </PopupConsumer>
    </div>)
  }
}

export default IndustrieSearch